var PersistentStorage = /** @class */ (function () {
    function PersistentStorage() {
    }
    PersistentStorage.get = function (key) {
        try {
            return localStorage.getItem(PersistentStorage.keyPrefix + key);
        }
        catch (_a) {
            return null;
        }
    };
    PersistentStorage.set = function (key, value) {
        try {
            localStorage.setItem(PersistentStorage.keyPrefix + key, value);
            return true;
        }
        catch (_a) {
            return false;
        }
    };
    PersistentStorage.keyPrefix = 'sw-';
    return PersistentStorage;
}());
export { PersistentStorage };
